var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPhysicalMedicineRehabilitation = function SvgPhysicalMedicineRehabilitation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 108 108",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".physical_medicine_rehabilitation{fill:none;stroke:#f9f9fa;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phys_Med_Rehab",
    "data-name": "Phys Med Rehab"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "physical_medicine_rehabilitation",
    x: 44.01,
    y: 30.17,
    width: 17.99,
    height: 4.91,
    rx: 2.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "physical_medicine_rehabilitation",
    d: "M45.64,35.53V49.77a.52.52,0,0,0,.07.25l6.91,10.64a.45.45,0,0,0,.76,0L60.29,50a.43.43,0,0,0,.07-.25V35.53a.45.45,0,0,0-.45-.45H46.09A.45.45,0,0,0,45.64,35.53Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "physical_medicine_rehabilitation",
    x1: 53,
    y1: 59.88,
    x2: 53,
    y2: 74.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "physical_medicine_rehabilitation",
    x1: 47.28,
    y1: 41.62,
    x2: 58.73,
    y2: 41.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "physical_medicine_rehabilitation",
    cx: 53.05,
    cy: 76.89,
    r: 1.81
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhysicalMedicineRehabilitation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/physical_medicine_rehabilitation.6755c7f5.svg";
export { ForwardRef as ReactComponent };